import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import moment from "moment";
import React from "react";
import { Controller } from "react-hook-form";
import { NameList } from "../../redux/reducers/timesheet.reducer";
import { IScheduleEvent } from "../../redux/reducers/schedule.reducer";

type PropsType = {
  control: any;
  scheduleOptionListOpen: boolean;
  setScheduleOptionListOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setMinDate: React.Dispatch<React.SetStateAction<string | null>>;
  setMaxDate: React.Dispatch<React.SetStateAction<string | null>>;
  setMinTime: React.Dispatch<React.SetStateAction<string | null>>;
  setMaxTime: React.Dispatch<React.SetStateAction<string | null>>;
  setValue: any;
  scheduleOptions: readonly NameList[];
  scheduleLoading: boolean;
  activeSchedule: any | null;
  errors: any;
};

export default function SelectScheduleInput(props: PropsType) {
  const {
    control,
    scheduleOptionListOpen,
    setScheduleOptionListOpen,
    setMinDate,
    setMaxDate,
    setMinTime,
    setMaxTime,
    setValue,
    scheduleOptions,
    scheduleLoading,
    activeSchedule,
    errors,
  } = props;

  return (
    <Controller
      control={control}
      name="schedule"
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          fullWidth
          id="schedule"
          open={scheduleOptionListOpen}
          onOpen={() => {
            setScheduleOptionListOpen(true);
          }}
          onClose={() => {
            setScheduleOptionListOpen(false);
          }}
          onChange={(event, item: IScheduleEvent) => {
            setValue(
              "shift_start_time",
              moment(item?.start_time).format("HH:mm:ss")
            );
            setMinDate(moment(item?.start_time).format("YYYY-MM-DD"));
            setMaxDate(moment(item?.end_time).format("YYYY-MM-DD"));

            setMinTime(moment(item?.start_time).format("HH:mm:ss"));
            setMaxTime(moment(item?.end_time).format("HH:mm:ss"));
            setValue(
              "shift_start_date",
              moment(item?.start_time).format("YYYY-MM-DD")
            );
            let momentDate = moment();
            let momentEndDate = moment(item?.end_time);
            if (momentEndDate.isSameOrBefore(momentDate)) {
              setValue(
                "shift_end_date",
                moment(item?.end_time).format("YYYY-MM-DD")
              );
              setValue(
                "shift_end_time",
                moment(item?.end_time).format("HH:mm:ss")
              );
            }
            onChange(item);
          }}
          value={value ? value : null}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => {
            const formattedDate = moment(option.start_time).format(
              "YYYY MMMM Do, HH:mm"
            );
            const formattedEndTime = moment(option.end_time).format("HH:mm");
            return `${formattedDate}~${formattedEndTime}`;
          }}
          options={scheduleOptions}
          loading={scheduleLoading}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select schedule"
              variant="standard"
              required={activeSchedule}
              error={!!errors["schedule"]}
              helperText={errors["schedule"] ? errors["schedule"].message : ""}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {scheduleLoading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      )}
    />
  );
}
